<template>
  <div class="w-full md:w-auto px-10">
    <form class="flex flex-col mt-12 lg:mt-20">
      <div class="flex justify-between">
        <label class="flex justify-start text-lg mb-4 uppercase tracking-widest">
          {{ $t('skills.bio') }}
        </label>
        <button class="w-4 my-1 mr-1 hover:text-background-academy" @click.prevent="updateBio">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" class="svg-inline--fa fa-check fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#9B9999" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
        </button>
      </div>
      <vue-editor v-model="bio">
        <textarea type="text" placeholder="Write here your bio!"
        class="h-32 w-full shadow-md flex items-start p-3
        overflow-y-auto break-words whitespace-normal list-disc"/>
      </vue-editor>
    </form>
    <div class="flex flex-col md:flex-row mt-20">
      <facebook-account class="mr-20 mb-6 md:mb-0" />
      <instagram-account />
    </div>

    <router-link :to="dashboardPath+'/skills'">
      <p class="font-sans-serif text-base shadow-lg rounded-sm mt-20 w-full md:w-1/4 p-1 transform
      hover:scale-105 duration-300 bg-beige-academy-300 text-white border
      border-beige-academy-300 hover:text-beige-academy-400 text-center
      hover:bg-white">
      {{$t('skills.complete')}}
      </p>
    </router-link>

    <update-password />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VueEditor } from 'vue2-editor';
import { updateTeacherData } from '@/services/TeacherService';
import FacebookAccount from '../graphics/FacebookAccount.vue';
import InstagramAccount from '../graphics/InstagramAccount.vue';
import UpdatePassword from '../UpdatePassword.vue';

export default {
  components: {
    VueEditor,
    FacebookAccount,
    InstagramAccount,
    UpdatePassword,
  },

  data() {
    return {
      bio: '',
    };
  },

  mounted() {
    this.bio = this.user.teacher.bio ? this.user.teacher.bio : '';
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
      dashboardPath: 'auth/dashboardPath',
    }),
  },

  methods: {
    updateBio() {
      updateTeacherData(this.user.teacher.id, { bio: this.bio }).then(() => {
        this.createNotification('success', this.$t('skills.success'));
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },

};
</script>
